import { render, staticRenderFns } from "./PerformanceTable.vue?vue&type=template&id=c8d2cf3e&scoped=true&"
import script from "./PerformanceTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PerformanceTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PerformanceTable.vue?vue&type=style&index=0&id=c8d2cf3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d2cf3e",
  null
  
)

export default component.exports